/* eslint-disable max-statements */
(function($) {
  'use strict';

  const $toggleBtn = $('#audience-toggle');
  if (!$toggleBtn.length) {
    return;
  }
  const $body = $('body');
  const $toggleLabel = $toggleBtn.find('.audience');
  const $currentAudience = $('.current-audience');
  const $requiredInternational = $('[data-required-international]');
  const $requiredDomestic = $('[data-required-domestic]');
  const buttonText = {
    domestic: 'Switch to International information',
    international: 'Switch to Domestic information',
  };
  const currentAudienceText = {
    domestic: 'Domestic students',
    international: 'International students',
  };
  const studentTypeValues = {
    domestic: 'Domestic',
    international: 'International',
  };
  const urlParam = {
    domestic: '',
    international: 'true',
  };

  function setParam(name, value) {
    const params = new URLSearchParams(window.location.search);
    if (value) {
      params.set(name, value);
    } else {
      // eslint-disable-next-line dot-notation
      params.delete(name);
    }
    window.history.replaceState(
      {},
      '',
      decodeURIComponent(
        `${window.location.pathname}${
          params.toString().length === 0 ? '' : '?'
        }${params}${window.location.hash}`
      )
    );
  }

  function setCurrentAudience(newAudienceType) {
    $body.attr('data-current-audience', newAudienceType);
    $toggleBtn.attr({
      'data-current-audience': newAudienceType,
      'data-gtm-value': newAudienceType,
    });
    $toggleLabel.text(buttonText[newAudienceType]);
    $currentAudience.text(currentAudienceText[newAudienceType]);
    setParam('international', urlParam[newAudienceType]);
    localStorage.setItem('audience', newAudienceType);
    $requiredInternational.attr({
      required: newAudienceType === 'international',
      'aria-required': newAudienceType === 'international',
    });
    $requiredDomestic.attr({
      required: newAudienceType === 'domestic',
      'aria-required': newAudienceType === 'domestic',
    });
  }

  // Find URL parameter and set localStorage if defined.
  let searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has('international')) {
    let param = searchParams.get('international');
    if ('true' === param) {
      localStorage.setItem('audience', 'international');
    }
  }

  // Check localStorage for the audience and set the button text accordingly.
  var storedAudience = localStorage.getItem('audience');
  setCurrentAudience(
    'international' === storedAudience ? 'international' : 'domestic'
  );

  // When the button is clicked, switch the text and store in localStorage.
  $toggleBtn.on('click', function() {
    let audienceType = $toggleBtn.attr('data-current-audience');
    let newAudienceType =
      audienceType === 'domestic' ? 'international' : 'domestic';

    setCurrentAudience(newAudienceType);
  });
})(jQuery);
